<template>
    <div>
        <div slot="table-busy" class="text-center small text-dark my-5 pt-5" v-if="isBusy === true">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>Loading...</strong>
        </div>
        <div class="mapContainer" aria-busy="false" v-if="isBusy === false ">
            <div class="gps-icon" @click="getLocation()"> <span class="small">GPS</span> </div>
            <div class="home-icon" @click="goToList()"> « </div>

            <div class="map">
                <l-map  :zoom.sync="zoom"
                        :options="mapOptions"
                        :zoom="zoom"
                        @update:zoom="zoomUpdated"
                        @update:center="centerUpdated"
                        @update:bounds="boundsUpdated"
                        :center="center">

                    <v-geosearch
                            :options="geosearchOptions"
                            id="mapSearchContainer"/>

                    <l-control-layers
                            :position="layersPosition"
                            :collapsed="false"
                            :sort-layers="true"/>

                    <l-tile-layer
                            v-for="tileProvider in tileProviders"
                            :key="tileProvider.name"
                            :name="tileProvider.name"
                            :visible="tileProvider.visible"
                            :url="tileProvider.url"
                            :attribution="tileProvider.attribution"
                            layer-type="base"/>

                    <l-control-zoom :position="zoomPosition" />

                    <l-control-attribution
                            :position="attributionPosition"
                            :prefix="attributionPrefix"/>

                    <l-control-scale :imperial="imperial" />

                    <l-marker :lat-lng="center"/>

                    <l-marker v-for="(customer) in customers"  :clickable="true" :draggable="true" @g-click="center=m.center"
                              :lat-lng="customer"
                              :key="customer.name"
                              :icon="customer.icon"
                              :visible="true">
                        <l-popup :content="customer.name" />
                    </l-marker>
                </l-map>
                <div class="footer">
                    <span>Center: {{ center }}</span><br>
                    <span>Zoom: {{ zoom }}</span><br>
                </div>
            </div>
        </div>
    </div>
</template>

<!--Leaftlat VUE2 examples
https://unpkg.com/browse/is-vue2-leaflet@0.0.9/examples/src/components/-->

<!-- For example if you want to listen to Vue2Leaflet.LMarker move event.
<l-marker :lat-lng="[47.413220, -1.219482]" @move="doSomething"></l-marker>-->

<!--Pulse marker GPS
https://codepen.io/andreasstorm/pen/ClguF-->

<script>
    import { db } from '../main';
    import L from "leaflet";
    import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
    import { OpenStreetMapProvider } from 'leaflet-geosearch';
    import { LPolyline, LLayerGroup, LControlZoom, LControlAttribution, LControlScale, LControlLayers } from "vue2-leaflet";
    import VGeosearch from 'vue2-leaflet-geosearch';
    import LCircle from "vue2-leaflet/dist/components/LCircle";
    import LControl from "vue2-leaflet/dist/components/LControl";
    import LPolygon from 'vue2-leaflet/dist/components/LPolygon'
    import LIcon from 'vue2-leaflet/dist/components/LIcon'
    import * as Vue2Leaflet from 'vue2-leaflet'

    const tileProviders = [
        {
            name: "StreetMap",
            visible: true,
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        },
        {
            name: "OpenToMap",
            visible: false,
            url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
            attribution:
                'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
        },
        {
            name: "Grey Map",
            visible: false,
            url: "http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png",
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    ];

    export default {
        name: 'Map',
        firestore () {
            return {
                customers: db.collection('customers')
            }
        },
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LTooltip,
            LPopup,
            LControl,
            LIcon,
            VGeosearch,
            LCircle,
            LPolygon,
            LPolyline,
            LLayerGroup,
            LControlZoom,
            LControlAttribution,
            LControlScale,
            LControlLayers,
        },

        data() {
            return {
                isBusy: true,
                error: '',              // If geolocation not is found
                customers: [
                    /*name: "Hälsö 1", id: 0, active: false, lng: 11.655, lat: 57.733333, icon: this.defaultIcon},*/
                    {name: "Hannas hem 1", lng: 12.114, lat: 57.741, },
                    {name: "Hannas hem 2", lng: 12.115, lat: 57.742, },
                    {name: "Hannas hem 3", lng: 12.116, lat: 57.743, }
                ],
                lat: null,
                lon: null,
                bounds: null,
                markers: [],
                items: [],

                mapOptions: {
                    zoomControl: false,
                    attributionControl: false,
                    zoomSnap: true,
                    draggable: true
                },

                zoom: 16,
                minZoom: 1,
                maxZoom: 20,
                center: L.latLng(57.733434, 11.652575),   /* kartans default värde */
                zoomPosition: "topleft",
                attributionPosition: "bottomright",
                layersPosition: "topright",
                attributionPrefix: "Vue2Leaflet",
                imperial: false,
                Positions: ["topleft", "topright", "bottomleft", "bottomright"],
                tileProviders: tileProviders,

                geosearchOptions: {
                    provider: new OpenStreetMapProvider({
                        position: 'topleft',
                        wrapper: 'findbox',
                        markerLocation: true,
                        autoType: false,
                        autoCollapse: true,
                        minLength: 5,
                        showMarker: true,
                        retainZoomLevel: true,
                        showPopup: true,
                        draggable: true,
                        style: 'bar',
                        initial: false,
                        zoom: 11,        // set zoom to found location when searched
                        marker: {
                            draggable: true
                        },
                    }),     //geosearchOptions
                    popupFormat: ({ query, result }) => result.label,
                    searchLabel: 'Sök adress',
                    keepResult: false,
                    showMarker: true,
                    retainZoomLevel: false,
                    initial: false,
                    zoom: 11,        // set zoom to found location when searched
                }
            }
        },

        beforeCreate() {
            //   document.getElementById('headersNoShow').style.display = "none";
            this.isBusy = true;
        },

        async  beforeMount(){
            await this.getForsynList();
            await this.getCustomersCoordinates();
        },
        mounted() {
            /*    Then in you JavaScript you can use mapObject which is Leaflet map instance :
                    this.$refs.map.mapObject;*/
            // this.$refs.map.mapObject.setView([57.7335133, 12.130170699999999], 15);
            // this.setMapLocation([57.7335133, 12.130170699999999], 16);
        },

        methods: {
            async getForsynList () {
                this.isBusy = true;
                await db.collection('customers').get().then(resp => {
                    let forsynListCollection = [];
                    resp.forEach(doc => {
                        const forsynListData = doc.data();
                        if(forsynListData.lat.length > 0 ){
                            forsynListCollection.push({
                                'id' : doc.id,
                                'name' : forsynListData.name,
                                'adress' : forsynListData.adress,
                                'status' : (Array.isArray(forsynListData.dthv) === true),
                                _showDetails: false,    /* Checkbox*/
                                'customer_color': forsynListData.color,
                                'fakturerad': forsynListData.invoiced,
                                'fastBet': forsynListData.fastBet,
                                'dateForsyn': forsynListData.dateForsyn,
                                'timeForsyn': forsynListData.timeForsyn,
                                'dateDigging': forsynListData.dateDigging,
                                'timeDigging': forsynListData.timeDigging,
                                'lat': forsynListData.lat,
                                'lng': forsynListData.lon,
                                'Status':  [forsynListData.fk,forsynListData.fthv,forsynListData.dthv,forsynListData.ttt],
                            })
                        }
                    });
                    this.customers = forsynListCollection;
                    this.isBusy = false;
                });
                await this.getCustomersCoordinates();
            },

            goToList () {
                this.$router.replace('/forsyn-list');
            },

            centerUpdated(center) {
                this.center = center;
            },

            /* Zoom, Center, Bounds gör att iconen flyttar på sig och aktuella koordinater visas */
            zoomUpdated (zoom) {
                this.zoom = zoom;
            },

            boundsUpdated (bounds) {
                this.bounds = bounds;
            },

            /* Sets the map coordinates and locates location on the map */
            setMapLocation: function (lat, lon, zoom) {
                this.$refs.map.mapObject.setView([lon, lat], zoom);
            },

            /* If it´s possible to retrieve current geo location, get showLocation */
            getLocation: function () {
                if(navigator.geolocation){
                    navigator.geolocation.getCurrentPosition(this.showLocation);
                }else{
                    this.error = "Geolocation is not supported.";
                }
            },

            /* Retrieving geo current location and display current coordinates */
            showLocation: function (position) {
                let lat = this.lat = position.coords.latitude;
                let lon = this.lon = position.coords.longitude;
                alert('Lat: ' + this.lat + ' Long: ' + this.lon);
            },

            onAdd: function(e){
                this.$nextTick( () => e.target.openPopup() )
            },

            getCustomersCoordinates() {
                const getCoords = {  getName: '' , getLat: '', getLong: ''  };

                // console.log('NAME!!! ' + JSON.stringify(this.customers));

                let i = 0;
                while(i <= this.customers) {
                    getCoords.getName = this.customers.name;
                    getCoords.getLat = this.customers.lat;
                    getCoords.getLong = this.customers.lng;
                }
                return getCoords;
            },
        }
    }
</script>

<style scoped lang="scss">

    #headerNoShow {
        display: none !important;
    }

    .mapContainer{
        min-height: 100%;
    }

    .map {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
    }

    div .gps-icon {
        margin-top: 20px;
        color: #333;
        position: fixed;
        top: 50px;
        left: 10px;
        display: flex;
        z-index: 1000;
        border: 2px solid #eee;
        line-height: 2;
        font-size: 14px;
        font-weight: 700;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: color 0.2s ease, background-color 0.2s ease, transform 0.3s ease;
        width: 50px;
        height: 50px;
        padding: 10px 15px;
        justify-content: center;
        align-content: center;
    }

    div .gps-icon, div .home-icon {
        /*  background-color: #88b2b9;*/
        background-color: white;
    }

    div .gps-icon:hover,  div .home-icon:hover {
        background-color: #ddd;
        color: black;
        cursor: pointer;
        box-shadow: none;
    }

    div .home-icon{
        margin-top: 40px;
        color: #333;
        position: fixed;
        top: 90px;
        left: 10px;
        display: flex;
        z-index: 1000;
        border: 2px solid #eee;
        line-height: 1.5;
        font-size: 20px;
        font-weight: 700;
        background: white;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: color 0.2s ease, background-color 0.2s ease, transform 0.3s ease;
        width: 50px;
        height: 50px;
        padding: 6px 8px;
        justify-content: center;
        align-content: center;
    }

    .footer {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 5000;
        padding: 5px 10px;
        font-size: 10pt;
        letter-spacing: -1;
        border: 2px solid #eee;
        background: rgba(255, 255, 255, 0.7);
    }
</style>



// WEBPACK FOOTER //
// src/views/Map.vue